import { isMobile } from 'mobile-device-detect'
import { BucketMedia } from '../../../graphql/generated'

export default function formatImageProxyUrl(media: BucketMedia | null, containerBoundary: number = Infinity) {
  if (!media?.imageUrl) return undefined

  const width = media.width ?? Infinity

  const params = {
    width: media.width?.toString() ?? '590',
    height: media.height?.toString() ?? '590',
    fit: 'bounds'
  }

  if (containerBoundary <= 590 && width >= 590) {
    params.width = '590'
    params.height = '590'
  }

  if (containerBoundary <= 320 && width >= 320) {
    params.width = '320'
    params.height = '320'
  }

  // preload thumbnail
  if (!isMobile && containerBoundary > 320 && width >= 320) {
    const thumbnailParams = {
      width: '320',
      height: '320',
      fit: 'bounds'
    }
    const thumbnailQuerystring = new URLSearchParams(thumbnailParams).toString()
    const thumbnail = new Image()
    thumbnail.src = `${media.imageUrl}?${thumbnailQuerystring}`
  }

  const querystring = new URLSearchParams(params).toString()

  return `${media.imageUrl}?${querystring}`
}
